import React, { useRef, useCallback } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import Affix from "../../../../../../../components/affix";
import { useLocation } from "react-router-dom";
import AutoWidthSwiper from "../../../../../../../components/swiper/autowidth";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { Iconfont } from "../../../../../../../components/icon/iconfont";
import { FormattedMessage } from "react-intl";
import { useState } from "react";
import { useEffect } from "react";
import Cache from "../../../../../../../../utils/cache";
import Header from "../../../../../../../components/header";

const OrderTabs = props =>{
    const { slideNext } = props;
    const Intl = useIntl();
    const location = useLocation();
    const [swiper, setSwiper] = useState(null);

    const initDataRef = useRef([
        {
            id:1,
            title: Intl.formatMessage({ id: "all", defaultMessage: "All" }),
            path:"/user/order/all"
        },
        {
            id:2,
            title: Intl.formatMessage({ id: "unpaid", defaultMessage: "Unpaid" }),
            path:"/user/order/unpaid"
        },
        {
            id:3,
            title: Intl.formatMessage({ id: "processing", defaultMessage: "Processing" }),
            path:"/user/order/processing"
        },
        {
            id: 4,
            title: Intl.formatMessage({ id: "shipped", defaultMessage: "Shipped" }),
            path:"/user/order/shipped"
        },
        {
            id: 5,
            title: Intl.formatMessage({ id: "review", defaultMessage: "Review" }),
            path:"/user/order/confirmed"
        },
        {
            id: 6,
            title: Intl.formatMessage({ id: "returns", defaultMessage: "Returns" }),
            path:"/user/order/return"
        }
    ]);


    useEffect(() =>{
        if(slideNext){
            swiper?.slideTo(3, 500);
        }
    }, [swiper, slideNext]);


    const tabActive = useCallback((pathname, path)=>{
        return pathname?.indexOf(path) >= 0
    },[]);

    return <div className={cls.OrderTabs}>
        <AutoWidthSwiper
            items={initDataRef.current}
            options={{
                slidesPerView: 3.5,
                onInit:setSwiper,
            }}
            render={(tab, index) =>{
                return <div key={tab.id+index}>
                    <Link to={tab.path} className={`${cls.TabItem} ${tabActive(location.pathname, tab.path) ? cls.Active : ''}`} replace>
                        <span>{tab.title}</span>
                    </Link>
                </div>
            }}
        />
    </div>
}

export default props =>{
    useStyles(cls);
    const Intl = useIntl();
    const [show, setShow] = useState(false);

    useEffect(() =>{
        let historyMessage = Cache.get("history_orders_message");
            if(!historyMessage){
                Cache.set("history_orders_message",true);
                setShow(true);
                setTimeout(() =>{
                    setShow(false);
                },3000);
            }
    }, []);

    return <div className={cls.OrderHeader}>
        <Affix offsetTop={0}>
            <Header 
                centerSlot={`${Intl.formatMessage({ id: "my_orders", defaultMessage: "My Orders" })}`} 
                rightSlot={
                    <React.Fragment>
                        <div className={cls.OrderHomeIcon}>
                            <Link to={`/user/order/history-orders`}>
                                <span className={cls.HistoryIcon}></span>
                            </Link>

                            <a href="/user/support">
                                <Iconfont className={cls.SupportIcon}>&#xe716;</Iconfont>
                            </a>
                        </div>
                    </React.Fragment>
                }
            >
                {
                    show && <div className={cls.HistoryOrderMessage}>
                        <FormattedMessage id="history_orders_message" defaultMessage="Click here to check your previous orders." />
                    </div>
                }
            </Header>

            <OrderTabs {...props} />
        </Affix>
    </div>
}